import { PlayIcon } from "@heroicons/react/24/solid";

interface QuickAction {
  id: string;
  text: string;
  icon?: string;
}

/**
 * 對話頁面底部輸入區域
 * 顯示快速操作按鈕和輸入框
 */
export function ConversationBottomNav({
  quickActions,
  textareaRef,
  isLoading,
  inputValue,
  handleInputChange,
  handleKeyPress,
  handleSendMessage,
  handleQuickActionClick,
}: {
  quickActions: QuickAction[];
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  isLoading: boolean;
  inputValue: string;
  handleInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleKeyPress: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  handleSendMessage: () => void;
  handleQuickActionClick: (action: QuickAction) => void;
}) {
  return (
    <>
      {/* 底部輸入區域 - 固定在螢幕底部 */}
      <div
        id="bottom-nav"
        className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom z-40"
      >
        {/* 快速操作區 */}
        {quickActions.length > 0 && (
          <div className="px-4 md:px-6 py-2 bg-[#F5F1E8]/50 border-t border-gray-100 dark:bg-gray-800/50 dark:border-gray-700">
            <div className="max-w-7xl mx-auto">
              <div className="flex space-x-2 overflow-x-auto pb-1">
                {quickActions.map((action) => (
                  <button
                    key={action.id}
                    onClick={() => handleQuickActionClick(action)}
                    className="text-md bg-[#6B8E5A]/10 text-[#6B8E5A] px-3 py-1 rounded-full whitespace-nowrap"
                  >
                    {action.text}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* 輸入框和發送按鈕 */}
        <div
          className="p-3 md:p-4"
          style={{
            paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))",
          }}
        >
          <div className="max-w-7xl mx-auto grid grid-cols-[1fr_auto] items-end gap-3">
            <div className="bg-gray-100 rounded-2xl flex items-end">
              <textarea
                ref={textareaRef}
                value={inputValue}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                placeholder="輸入您的問題或需求..."
                rows={1}
                className="w-full bg-transparent border-none outline-none resize-none px-4 py-3 max-h-32 text-md md:text-base"
                disabled={isLoading}
              />
              {/* <button className="p-3 text-[#A0956B] hover:text-[#6B8E5A] transition-colors">
                <MicrophoneIcon className="w-5 h-5" />
              </button> */}
            </div>
            <button
              onClick={handleSendMessage}
              disabled={isLoading || !inputValue.trim()}
              className={
                "w-12 h-12 bg-[#6B8E5A] text-white rounded-full flex items-center justify-center flex-shrink-0 hover:bg-[#9BBF85] " +
                "transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              }
            >
              <PlayIcon className="w-5 h-5 min-w-5 min-h-5" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
